import DOMPurify from 'dompurify';
import { SerializedEditorState } from 'lexical';
import { useMemo } from 'react';
import { TextEditorHandler } from '../handlers/textEditorHandler';

const textEditorHandler = TextEditorHandler.instance;

type GetEditorStateFnOrKeyType =
  | (() => SerializedEditorState | string | null)
  | string;

type HtmlObject = { html: string | null };

export function useEditorStateToHtml(
  getEditorStateFnOrKey: GetEditorStateFnOrKeyType,
  deps: any[],
): HtmlObject {
  const editorState = useMemo(() => {
    if (typeof getEditorStateFnOrKey === 'string')
      return textEditorHandler.getEditorStateFromLocalStorage(
        getEditorStateFnOrKey,
      )?.editorState;

    return getEditorStateFnOrKey();
  }, deps);

  if (!editorState) return { html: null };

  let parsedEditorState: SerializedEditorState =
    typeof editorState === 'string' ? JSON.parse(editorState) : editorState;

  const html = textEditorHandler.convertToHtml(parsedEditorState);

  const sanitizedHtml = DOMPurify.sanitize(html);

  return { html: sanitizedHtml };
}
